/**
 * @generated SignedSource<<e6098bb3f382b1e3e935f426d6d92cde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useConferencingOptionsRefreshQuery$variables = {};
export type useConferencingOptionsRefreshQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"useConferencingOptions_viewer">;
  };
};
export type useConferencingOptionsRefreshQuery = {
  response: useConferencingOptionsRefreshQuery$data;
  variables: useConferencingOptionsRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useConferencingOptionsRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useConferencingOptions_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useConferencingOptionsRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultConferenceProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasMeetingWriteScope",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarConnection",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Calendar",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ca7eab36f61e70bb993f3e63c539b74",
    "id": null,
    "metadata": {},
    "name": "useConferencingOptionsRefreshQuery",
    "operationKind": "query",
    "text": "query useConferencingOptionsRefreshQuery {\n  viewer {\n    ...useConferencingOptions_viewer\n    id\n  }\n}\n\nfragment useConferencingOptions_viewer on Viewer {\n  id\n  defaultConferenceProvider\n  user {\n    id\n  }\n  integrations {\n    zoom {\n      id\n      hasMeetingWriteScope\n    }\n  }\n  calendars {\n    edges {\n      node {\n        id\n        source\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef69d3681d846460dc7b5654cb690923";

export default node;
